import footer from "./default.json";

export function getFooterPageData() {
  return footer;
}
